import React__default from 'react';
import styled from 'styled-components';
import { b as TouchLinkContent, c as TouchLinkIcon } from '../TouchLink.styles-D0GPtYUj.js';
import { b as angleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

const InlineTouchLinkContent = /*#__PURE__*/styled(TouchLinkContent).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1r9go5x-0"
})(["background-color:unset;border:none;border-radius:0px;padding:0;"]);
const InlineTouchLinkIcon = /*#__PURE__*/styled(TouchLinkIcon).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1r9go5x-1"
})(["left:auto;inset-inline-start:auto;right:0;inset-inline-end:0;[dir=\"rtl\"] &&{right:auto;inset-inline-start:auto;left:0;inset-inline-end:0;}"]);
const InlineTouchLinkBody = ({
  children
}) => /*#__PURE__*/React__default.createElement(InlineTouchLinkContent, null, children, /*#__PURE__*/React__default.createElement(InlineTouchLinkIcon, {
  type: angleInlineEnd,
  size: "lg"
}));

export { InlineTouchLinkBody as I };
//# sourceMappingURL=InlineTouchLinkBody-L2w2PtB5.js.map
